/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'

const CompanyAuthLayout = () => {
    useEffect(() => {
        const root = document.getElementById('root')
        if (root) {
            root.style.height = '100%'                  
        }        
        document.body.style.backgroundColor = "#2d3945";
        
        return () => {
            if (root) {
                root.style.height = 'auto'
            }
            document.body.style.backgroundColor = "#f5f8fa";
        }
    }, [])

    return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
        {/* begin::Body */}
        <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
            {/* begin::Form */}
            <div className='d-flex flex-center flex-column flex-lg-row-fluid mt-lg-n40'>
                {/* begin::Wrapper */}
                <div className='p-10'>
                    <Outlet />
                </div>
                {/* end::Wrapper */}
            </div>
            {/* end::Form */}        
        </div>
        {/* end::Body */}      
    </div>
    )
}

export {CompanyAuthLayout}
